/**
 * 编辑页附加信息
 * created by lzy 2020/07/06
 */
'use strict';
angular.module('editPageExtrasModule', []).directive('editPageExtras', ['Upload', 'modalDialog',
    function(Upload, modalDialog) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/editPageExtras/editPageExtras.html',
            transclude: true,
            replace: true,
            link: function($scope) {
                // initStatus();
                // initData();

                /**
                 * [initStatus description]
                 * @return  {[type]}   [return description]
                 */
                // function initStatus() {
                // }

                /**
                 * [initData description] 初始化数据
                 * @return  {[type]}   [return description]
                 */
                // function initData() {
                // }

                /**
                 * [upload description]文件上传事件
                 * @param  {[type]}  files   [files description]
                 * @return  {[type]}   [return description]
                 */
                $scope.extrasUpload = function(files) {
                    if (!files || !files.length) {
                        return;
                    }
                    if (!$scope.list.BGAPPENDIX) {
                        $scope.list.BGAPPENDIX = [];
                    }
                    for (var i = 0; i < files.length; i++) {
                        var file = {
                            SRCFILE: files[i].name,
                            FILEINFO: '正在上传',
                            APPDESC: files[i].name.substring(0, files[i].name.lastIndexOf('.')),
                            file: files[i]
                        };
                        $scope.list.BGAPPENDIX.push(file);
                        uploadFile(file);
                    }
                };

                /**
                 * [uploadAgain description] 重新上传
                 * @param  {[type]}  file   [file description]
                 * @param  {[type]}  index   [file description]
                 * @return  {[type]}   [return description]
                 */
                $scope.extrasUploadAgain = function(file, index) {
                    file.FILEINFO = '正在上传';
                    uploadFile(file);
                };

                /**
                 * [uploadFile description] 附件上传方法
                 * @param  {[type]}  file   [file description]
                 * @param  {[type]}  fileObj   [file description]
                 * @return  {[type]}   [return description]
                 */
                function uploadFile(file) {
                    if (file.FILEINFO === '正在上传') {
                        Upload.upload({
                            url: '/wcm/openapi/uploadFile',
                            data: {
                                file: file.file
                            }
                        }).then(
                            function (resp) {
                                if (resp.data.success) {
                                    delete file.file;
                                    file.FILEINFO = '上传成功';
                                    file.APPFILE = resp.data.imgName;
                                    file.SRCPICURL = resp.data.imgSrc;
                                } else if (resp.data.error) {
                                    file.FILEINFO = '上传失败';
                                }
                            },
                            function (resp) {
                                file.FILEINFO = '上传失败';
                            },
                            function (evt) {
                                file.FILEINFO = '正在上传';
                            }
                        );
                    }
                }

                /**
                 * [delete description] 删除文件方法
                 * @param  {[type]}  index   [index description]
                 * @return  {[type]}   [return description]
                 */
                $scope.extrasDelete = function(index) {
                    $scope.list.BGAPPENDIX.splice(index, 1);
                };

                /**
                 * [move description] 文件位置移动方法
                 * @param  {[type]}  index   [index description] 原来位置
                 * @param  {[type]}  targetIndex   [targetIndex description] 目标位置
                 * @return  {[type]}   [return description]
                 */
                $scope.extrasMove = function(index, targetIndex) {
                    $scope.list.BGAPPENDIX[index] = $scope.list.BGAPPENDIX.splice(targetIndex, 1, $scope.list.BGAPPENDIX[index])[0];
                };

                /**
                 * [checkTheFile description] 检查所有文件是否上传完成
                 * @return  {[type]}   [return description]
                 */
                $scope.extrasCheckTheFileSuccess = function() {
                    if ($scope.status.isFusionEditor) {
                        return true;
                    }
                    for (var i = 0; i < $scope.list.BGAPPENDIX.length; i++) {
                        var file = $scope.list.BGAPPENDIX[i];
                        if (file.FILEINFO === '正在上传' || file.FILEINFO === '上传失败') {
                            modalDialog.alertType('还有文件正在上传或上传失败', '', 'warning', false);
                            return false;
                        }
                    }
                    return true;
                };
            }
        };
    }
]).filter('truncatedString', function() {
    return function(str) {
        var arr = str.split('.');
        var type = arr.pop();
        var name = arr.join('.');
        if (name.length > 13) {
            return name.substr(0, 11) + '...' + name.slice(-2) + '.' + type;
        }
        return str;
    };
});
